import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Home2 from './views/Home2.vue'

Vue.use(Router)

import demo from './routes/demo'
import guanhuai from './routes/guanh'
import dingd from './routes/dingd'
import dingdmain from './routes/dingdmain'
import basic from './routes/basic'
import xiangm from './routes/xiangm'
import xuqiu from './routes/xuqiu'
import price from './routes/price'
import jingpin from './routes/jingp'
import yuce from './routes/yuce'
import credit from './routes/credit'
import processLayout from './routes/processLayout'
import moneyBack from './routes/moneyBack'
import contract from './routes/contract'
import firstPage from './routes/firstPage'
import dailishang from './routes/dailishang'
import ProcessEngine from './routes/ProcessEngine'
import chanpin from './routes/chanpin'
import feiyong from './routes/feiyong'
import dalishang from './routes/agent'
import loud from './routes/loud'
import loudnew from './routes/loudNew'
import agent from "./routes/agent"
import formula from './routes/formula'
import personal from './routes/personal'
import commonality from './routes/commonality'
import cost from './routes/cost'
import msgFunnel from './routes/msgFunnel'
import paodong from './routes/paodong'
import yonghu from './routes/yonghu'
import establish from './routes/establish'
import leaveoffice from './routes/leaveoffice'
import weekforecast from './routes/weekforecast';
import invoice from './routes/invoice';
import weekMeeting from './routes/weekMeeting';
import agentAbility from './routes/agentAbility';
import reform from './routes/reform';
import specificGy from './routes/specificGy';
import board from './routes/board';

export default new Router({
  mode: process.env.VUE_APP_ROUTERMODE,
  base: process.env.BASE_URL,
  routes: [

    // 登陆
    {
      path: '/login',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/Login.vue'),
    },
    // 单点登陆
    {
      path: '/ssoLogin',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/SsoLogin.vue'),
    },
    // 单点测试
    {
      path: '/singleLogin',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/singleLogin.vue'),
    },
    // 注册
    {
      path: '/sign',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/sign.vue'),
    },
    // 首次注册配置页
    {
      path: '/firstlogin',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/FirstLoginConfig.vue'),
    },
    // 账号申诉
    {
      path: '/account_complaint',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/account_complaint.vue'),
    },
    // 密码重置
    {
      path: '/resetPass',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/resetPass.vue'),
    },

    // 空白页
    {
      path: '/twoLogin',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/twoLogin.vue'),
    },
    // 强制密码重置
    {
      path: '/resetPassPage',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/resetPassPage.vue'),
    },
    // 新密码提交
    {
      path: '/resetPassSave',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/resetPassSave.vue'),
    },
    {
      path: '/NotFound',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/NotFound.vue'),
    },
    {
      path: '/abnormal',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/abnormal.vue'),
    },
    // 单点测试
    {
      path: '/cluesLogin',
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/cluesLogin.vue'),
    },
    {
      path: '/lq',
      component: Home2,
      children: [
        {
          path: '/lq_riqingpingjia',
          // which is lazy-loaded when the route is visited.
          component: () => import('@/views/guanhuai/riqing/riqingpingjia.vue')
        },
        {
          path: '/lq_riqingReport',
          // which is lazy-loaded when the route is visited.
          component: () => import('@/views/guanhuai/riqing/riqingReport.vue')
        },

        {
          path: '/lq_muBiaoMonth',
          // which is lazy-loaded when the route is visited.
          component: () => import('@/views/guanhuai/mubiao/muBiaoMonth.vue')
        },
        {
          path: '/lq_muBiaoWeek',
          // which is lazy-loaded when the route is visited.
          component: () => import('@/views/guanhuai/mubiao/muBiaoWeek.vue')
        },
        {
          path: '/lq_dakajilu',
          // which is lazy-loaded when the route is visited.
          component: () => import('@/views/guanhuai/dakajilu/dakajilu.vue')
        },
        //协同管理主页面
        {
          path: '/lq_newResourceList',
          // which is lazy-loaded when the route is visited.
          component: () => import('@/views/guanhuai/xietongguanli/newResourceList.vue')
        },
        //项目管理主页面
        {
          path: '/lq_dailyTargetProject',
          // which is lazy-loaded when the route is visited.
          component: () => import('@/views/guanhuai/targetProject/dailyTargetProject.vue')
        },
      ]
    },
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '/',
          component: () => import('@/views/main/main.vue'),
          meta: {
            title: '今日待办',
            isTabsPage: true
          }
        },
        ...demo,
        ...guanhuai,
        ...dingd,
        ...dingdmain,
        ...basic,
        ...xiangm,
        ...xuqiu,
        ...price,
        ...jingpin,
        ...yuce,
        ...credit,
        ...processLayout,
        ...moneyBack,
        ...contract,
        ...dailishang,
        ...firstPage,
        ...ProcessEngine,
        ...chanpin,
        ...feiyong,
        ...chanpin,
        ...chanpin,
        ...dalishang,
        ...chanpin,
        ...loud,
        ...loudnew,
        ...agent,
        ...formula,
        ...personal,
        ...commonality,
        ...yonghu,
        ...cost,
        ...msgFunnel,
        ...paodong,
        ...establish,
        ...leaveoffice,
        ...weekforecast,
        ...invoice,
        ...agentAbility,
        ...weekMeeting,
        ...reform,
        ...specificGy,
        ...board
      ]
    },
  ]
})
